export default function ProjectFollowButton({
  isFollowing,
  onClick,
  size = 'md',
  className = ''
}) {
  const sizeClasses = {
    sm: 'w-7 h-7',
    md: 'w-10 h-10',
    lg: 'w-12 h-12'
  }

  const iconSize = sizeClasses[size] || sizeClasses.md

  return (
    <button
      onClick={onClick}
      className={`p-2 transition-all duration-200 hover:scale-110 active:scale-95 ${className}`}
      aria-label={isFollowing ? 'Unfollow project' : 'Follow project'}
    >
      <svg
        className={`${iconSize} transition-all duration-150 drop-shadow-lg ${
          isFollowing
            ? 'fill-white text-white scale-100'
            : 'fill-none text-white stroke-2'
        }`}
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        />
      </svg>
    </button>
  )
}
